import { render, staticRenderFns } from "./haokaShop.vue?vue&type=template&id=3fc11d52&scoped=true&"
import script from "./haokaShop.vue?vue&type=script&lang=js&"
export * from "./haokaShop.vue?vue&type=script&lang=js&"
import style0 from "./haokaShop.vue?vue&type=style&index=0&id=3fc11d52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc11d52",
  null
  
)

export default component.exports